import i18next, { t } from 'i18next';
import { ILanguage } from 'services/enums/types';
import { ITitle } from 'services/types';

export const getLanguageSelectOptions = (
  languages?: ILanguage[],
  selectedTitles: ITitle[] = []
) => {
  const selectedLanguages = selectedTitles.map(({ language }) => language);

  const filteredLanguages = languages
    ?.sort((a, b) => {
      const isACurrent = a.code.includes(i18next.language);
      const isBCurrent = b.code.includes(i18next.language);
      if (isACurrent && !isBCurrent) return -1;
      if (!isACurrent && isBCurrent) return 1;
      return 0;
    })
    ?.map(l => ({ value: l.id, label: t(`enum.LANGUAGE.${l.id}`) }))
    .filter(option => !selectedLanguages.includes(option.value));

  return filteredLanguages;
};
